// DS1.7.9
import React from 'react';
import classname from 'classnames';
import s from './DailyDeviationIndicator.scss';
const DailyDeviationIndicator = ({ size, withHoverEffect, className })=>/*#__PURE__*/ React.createElement("div", {
        className: classname(s['root'], s[size], withHoverEffect && s['hoverable'], className)
    });
DailyDeviationIndicator.displayName = 'DailyDeviationIndicator';
export default DailyDeviationIndicator;
